import { render, staticRenderFns } from "./edit-group-modal.vue?vue&type=template&id=025288d0&scoped=true"
import script from "./edit-group-modal.vue?vue&type=script&lang=js"
export * from "./edit-group-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025288d0",
  null
  
)

export default component.exports